// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let UserSession = require("../../common/UserSession/UserSession.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function getFirstCharacter(str) {
  return str.slice(0, 1);
}

function ClientAccess__Components__Avatar(props) {
  let __usePlaceholder = props.usePlaceholder;
  let __size = props.size;
  let size = __size !== undefined ? __size : "normal";
  let usePlaceholder = __usePlaceholder !== undefined ? __usePlaceholder : false;
  let clientInfo = UserSession.useClientInfoOpt();
  let tmp;
  if (usePlaceholder) {
    tmp = JsxRuntime.jsx("img", {
      className: "block w-full h-full object-cover",
      src: AvatarSrcUrl.place_holder
    });
  } else if (clientInfo !== undefined) {
    let match = clientInfo.profilePhoto;
    if (match !== undefined) {
      let profilePictureSize = size === "normal" ? 50 : 40;
      tmp = JsxRuntime.jsx("img", {
        className: "block w-full h-full object-cover",
        src: AvatarSrcUrl.from_key(profilePictureSize, profilePictureSize, match.key)
      });
    } else {
      let initials = clientInfo.firstName.slice(0, 1) + clientInfo.lastName.slice(0, 1);
      tmp = JsxRuntime.jsx("span", {
        children: initials,
        className: TailwindMerge.twMerge([
          "text-gray-600 uppercase font-normal",
          size === "normal" ? "text-[22px]" : "text-lg"
        ])
      });
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: TailwindMerge.twMerge([
      "flex shrink-0 rounded-full justify-center items-center overflow-hidden bg-gray-100",
      size === "normal" ? "w-10 h-10" : "w-[30px] h-[30px]"
    ])
  });
}

let make = ClientAccess__Components__Avatar;

exports.getFirstCharacter = getFirstCharacter;
exports.make = make;
/* UserSession Not a pure module */
